import { render } from "./PropertyWarningModal.vue?vue&type=template&id=ae5e441a&scoped=true&ts=true"
import script from "./PropertyWarningModal.vue?vue&type=script&lang=ts"
export * from "./PropertyWarningModal.vue?vue&type=script&lang=ts"

import "./PropertyWarningModal.vue?vue&type=style&index=0&id=ae5e441a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5e441a"]])

export default __exports__